// resources/js/api/jsErrorsHandling.js
import axiosInstance from "../configs/axios";
import { route } from "ziggy-js";

/**
 * Central definition of JS error reporting endpoint.
 */
export const JS_ERRORS_ENDPOINT = route("jsapi.error-reporting");

/**
 * Primary transport for JS error logs.
 * Fire-and-forget – odpoveď nás nezaujíma.
 */
export function sendJsErrorViaAxios(payload = {}) {
    return axiosInstance.post(JS_ERRORS_ENDPOINT, payload, {
        toastMsg: null,
    });
}
